<template>
  <el-dialog
    :visible.sync="Visible"
    :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-row>
      <el-button
        class="pull-right bottom-10"
        icon="el-icon-plus"
        size="mini"
        @click="addRow"
        type="primary"
      >新增行</el-button>
      <el-table :data="tableData" size="mini" border>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type size="mini" class="myshowup" @click="deleteRow(scope.$index)">删除当前行</el-button>
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="times">
          <template slot-scope="scope">
            <el-button type size="mini" class="myshowup" @click="editTimes(scope.$index)">编辑</el-button>
            {{scope.row.times}}
          </template>
        </el-table-column>
        <el-table-column label="公式" prop="formula">
          <template slot-scope="scope">
            <el-button type size="mini" class="myshowup" @click="editFormula(scope.$index)">编辑</el-button>
            {{scope.row.formula}}
          </template>
        </el-table-column>
        <el-table-column label="有效期" prop="validity">
          <template slot-scope="scope">
            <el-button type size="mini" class="myshowup" @click="editValidity(scope.$index)">编辑</el-button>
            {{scope.row.validity}}
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row v-if="formulaVisible">
      <h3>公式编辑：</h3>
      <el-input class="formula" type="textarea" v-model="formula" rows="2" readonly="readonly"></el-input>
      <el-col :span="3">
        <el-button-group>
          <el-button type="primary" size="medium" @click="setCalc(1)">1</el-button>
          <el-button type="primary" size="medium" @click="setCalc(2)">2</el-button>
          <el-button type="primary" size="medium" @click="setCalc(3)">3</el-button>
        </el-button-group>
        <el-button-group>
          <el-button type="primary" size="medium" @click="setCalc(4)">4</el-button>
          <el-button type="primary" size="medium" @click="setCalc(5)">5</el-button>
          <el-button type="primary" size="medium" @click="setCalc(6)">6</el-button>
        </el-button-group>
        <el-button-group>
          <el-button type="primary" size="medium" @click="setCalc(7)">7</el-button>
          <el-button type="primary" size="medium" @click="setCalc(8)">8</el-button>
          <el-button type="primary" size="medium" @click="setCalc(9)">9</el-button>
        </el-button-group>
        <el-button-group>
          <el-button type="primary" size="medium" @click="setCalc('.')">.&nbsp;</el-button>
          <el-button type="primary" size="medium" @click="setCalc(0)">0</el-button>
          <!-- <el-button type="primary" size="medium" @click="setCalc('=')">=</el-button> -->
        </el-button-group>
      </el-col>
      <el-col :span="3">
        <el-button-group class="computed01">
          <el-button type="primary" size="medium" @click="setCalc('+')">+</el-button>
          <el-button type="primary" size="medium" @click="setCalc('-')">-</el-button>
        </el-button-group>
        <el-button-group class="computed01">
          <el-button type="primary" size="medium" @click="setCalc('*')">*</el-button>
          <el-button type="primary" size="medium" @click="setCalc('/')">/</el-button>
        </el-button-group>
        <el-button-group class="computed01">
          <el-button type="primary" size="medium" @click="setCalc('(')">(</el-button>
          <el-button type="primary" size="medium" @click="setCalc(')')">)</el-button>
        </el-button-group>
        <el-button-group class="computed02">
          <el-button type="primary" size="medium" @click="setCalc('结算方式')">结算方式</el-button>
        </el-button-group>
      </el-col>
      <el-col :span="3">
        <el-button-group class="computed02">
          <el-button type="primary" size="medium" @click="backformula">保存公式</el-button>
        </el-button-group>
        <el-button-group class="computed02">
          <el-button type="info" size="medium" @click="clearformula">清除公式</el-button>
        </el-button-group>
      </el-col>
      <el-col :span="15">
        <div>
          <p>提示：</p>
          <p>1. 公式是必填项，编辑后请点击按钮“保存公式”。</p>
          <p>2. 若要清除公式，请点击按钮“清除公式”。</p>
          <p>3. 按钮“结算方式”代表当前科目行的结算方式。</p>
        </div>
      </el-col>
    </el-row>

    <el-row v-if="timesVisible">
      <h3>时间编辑：</h3>
      <el-col :span="9">
        <el-form ref="form" label-width="82px" class="timeedit">
          <el-form-item label="选择时间：">
            <el-radio-group v-model="timeradio">
              <el-radio-button size="medium" label="自选时间段"></el-radio-button>
              <el-radio-button size="medium" label="周末"></el-radio-button>
              <el-radio-button size="medium" label="节假日"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div v-if="timeradio == '自选时间段'">
            <el-form-item label="时间段：">
              <el-select v-model="tbegin" placeholder="请选择">
                <el-option
                  v-for="item in timerange"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <span>&nbsp;&nbsp;--&nbsp;&nbsp;</span>
              <el-select v-model="tend" placeholder="请选择">
                <el-option
                  v-for="item in timerange"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label=" ">
            <el-button type="primary" size="medium" @click="backtimes">保存时间</el-button>
            <el-button type="info" size="medium" @click="cleartimes">清除时间</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="15">
        <div>
          <p>提示：</p>
          <p>1. 时间是非必填项，但同一有效期内只允许一条手续费规则的时间是空值，代表默认时间。</p>
          <p>2. 编辑后请点击按钮“保存时间”。</p>
          <p>3. 若要清除时间，请点击按钮“清除时间”。</p>
        </div>
      </el-col>
    </el-row>

    <el-row v-if="validityVisible">
      <h3>有效期编辑：</h3>
      <el-col :span="9">
        <el-form ref="form" label-width="82px" class="validityedit">
          <el-form-item label="开始日期：">
            <el-date-picker
              v-model="bdate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期：">
            <el-date-picker
              v-model="edate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="primary" size="medium" @click="backvalidity">保存有效期</el-button>
            <el-button type="info" size="medium" @click="clearvalidity">清除有效期</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="15">
        <div>
          <p>提示：</p>
          <p>1. 有效期是非必填项，空值代表无例外有效期的其他日期都遵循本组规则。</p>
          <p>2. 编辑后请点击按钮“保存有效期”。</p>
          <p>3. 若要清除有效期，请点击按钮“清除有效期”。</p>
        </div>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button type="info" size="medium" @click="closeDialog" icon="el-icon-close">取 消</el-button>
      <el-button type="primary" size="medium" @click="backServiceCharge" icon="el-icon-check">确 认</el-button>
    </span>
  </el-dialog>
</template>
  
<script>
import config from "../../common/config";
export default {
  data() {
    return {
      Visible: false,
      timesVisible: false,
      formulaVisible: false,
      validityVisible: false,
      loading: true,
      index: 0,
      tableindex: 0,
      serviceCharge: "",
      tableData: [],
      oppositeSubjectName: "",
      title: "",
      times: "",
      formula: "",
      timeradio: "",
      tbegin: "",
      tend: "",
      timerange: [],
      bdate: "",
      edate: ""
    };
  },
  created() {
    this.timerange = [];
    for (let i = 1; i <= 31; i++) {
      this.timerange.push({ value: i, label: i });
    }
  },
  methods: {
    open(index, serviceCharge, oppositeSubjectName) {
      this.Visible = true;
      this.index = index;
      this.serviceCharge = "";
      this.tableData = [];
      this.serviceCharge = serviceCharge;
      if (serviceCharge != null && serviceCharge != "") {
        var serviceChargeJSON = JSON.parse(serviceCharge);
        serviceChargeJSON.forEach(item => {
          var times = item.时间;
          if (times != null && times.length > 2 && times.indexOf("-")) {
            var timebe = times.split("-");
            if (timebe != null && timebe.length > 1) {
              times = timebe[0] + "号-" + timebe[1] + "号";
            }
          }
          this.tableData.push({
            times: times,
            formula: item.公式,
            validity: item.有效期
          });
        });
      }
      this.oppositeSubjectName =
        oppositeSubjectName == "" ? "结算方式" : oppositeSubjectName;
      this.title = oppositeSubjectName + "手续费编辑";
    },
    //回写手续费并关闭对话框
    backServiceCharge() {
      var serviceChargeJSON = [];
      var i = 1;
      // var j = 0;
      var b = true;
      this.tableData.forEach(item => {
        //检查时间和公式必填项：公式所有不能为空，时间最多有一个可以为空
        if (b) {
          var timesStr = item.times;
          if (timesStr.indexOf("-")) {
            var timebe = timesStr.split("-");
            if (timebe != null && timebe.length > 1) {
              if (timebe[0].length > 1 && timebe[1].length > 1) {
                timesStr =
                  timebe[0].substring(0, timebe[0].length - 1) +
                  "-" +
                  timebe[1].substring(0, timebe[1].length - 1);
              }
            }
          }
          if (item.formula == null || item.formula.trim() == "") {
            this.$message({
              type: "info",
              message: "第" + i + "行公式不能为空"
            });
            b = false;
          }
          serviceChargeJSON.push({
            时间: timesStr,
            公式: item.formula,
            有效期: item.validity
          });
          i = i + 1;
        }
      });
      //检查
      //有效期 互斥性
      //时间 重复性和互斥性：同一有效期内不可以有重复的节假日和周末，自选时间段多条之间时间互斥
      //时间 无遗漏：同一有效期内单条或多条时间必须撑满整月
      if (b) {
        //以有效期分组
        var validitys = [];
        serviceChargeJSON.forEach(item => {
          if (validitys.length == 0) {
            var values = [];
            values.push(item);
            validitys.push({ key: item.有效期, value: values });
          } else {
            var exist = false;
            validitys.forEach(x => {
              if (x.key == item.有效期) {
                exist = true;
                var values = x.value;
                values.push(item);
                x.value = values;
              }
            });
            if (!exist) {
              var values = [];
              values.push(item);
              validitys.push({ key: item.有效期, value: values });
            }
          }
        });
        //以有效期分组end

        //有效期互斥
        validitys.forEach(y => {
          if (b) {
            if (y.key != null && y.key != "" && y.key.indexOf("到") >= 0) {
              var olddJSON = y.key.split("到");
              var oldbdate = new Date(olddJSON[0]);
              var oldedate = new Date(olddJSON[1]);
              validitys.forEach(newy => {
                if (
                  b &&
                  y.key != newy.key &&
                  newy.key != null &&
                  newy.key != "" &&
                  newy.key.indexOf("到") >= 0
                ) {
                  var newdJSON = newy.key.split("到");
                  var newbdate = new Date(newdJSON[0]);
                  var newedate = new Date(newdJSON[1]);
                  //如果基础有效期的开始时间为空，结束时间不为空
                  if (
                    (oldbdate == null || oldbdate == "") &&
                    (oldedate != null && oldedate != "")
                  ) {
                    //如果比较有效期的开始时间为空
                    if (newbdate == null || newbdate == "") {
                      b = false;
                    } else {
                      //如果比较有效期的开始时间不为空
                      //基础有效期的结束时间大于比较有效期的开始时间
                      if (oldedate >= newbdate) {
                        b = false;
                      }
                    }
                  }
                  //如果基础有效期的开始时间不为空，结束时间为空
                  else if (
                    oldbdate != null &&
                    oldbdate != "" &&
                    (oldedate == null || oldedate == "")
                  ) {
                    //如果比较有效期的结束时间为空
                    if (newedate == null || newedate == "") {
                      b = false;
                    } else {
                      //如果比较有效期的结束时间不为空
                      //基础有效期的开始时间大于比较有效期的结束时间
                      if (oldbdate > newedate) {
                        b = false;
                      }
                    }
                  }
                  //如果基础有效期的开始时间和结束时间都不为空
                  else {
                    //基础有效期的开始时间在 比较有效期的区间内
                    if (newbdate <= oldbdate && oldbdate <= newedate) {
                      b = false;
                    }
                    //比较有效期的开始时间在 基础有效期的区间内
                    else if (oldbdate <= newbdate && newbdate <= oldedate) {
                      b = false;
                    }
                    //比较有效期的结束时间为空，开始时间小于 基础有效期的结束时间
                    else if (
                      newbdate <= oldedate &&
                      (newedate == null || newedate == "")
                    ) {
                      b = false;
                    }
                    //比较有效期的开始时间为空，结束时间大于 基础有效期的开始时间
                    else if (
                      oldbdate <= newedate &&
                      (newbdate == null || newbdate == "")
                    ) {
                      b = false;
                    }
                  }
                  if (!b) {
                    this.$message({
                      type: "info",
                      message: "有效期“" + y.key + "“和“" + newy.key + "”互斥"
                    });
                    return false;
                  }
                }
              });
            }
          }
        });
        //有效期互斥end

        //时间 重复性和互斥性：同一有效期内不可以有重复的节假日和周末，自选时间段多条之间时间互斥
        if (b) {
          validitys.forEach(z => {
            if (b) {
              var jiejiari = false;
              var zhoumo = false;
              var kongzhi = false;
              var nums = [];
              var values = z.value;
              values.forEach(timesandformula => {
                //节假日重复
                if (timesandformula.时间 == "节假日") {
                  if (jiejiari) {
                    this.$message({
                      type: "info",
                      message:
                        "有效期“" +
                        timesandformula.有效期 +
                        "“有多条节假日的公式"
                    });
                    b = false;
                    return false;
                  } else {
                    jiejiari = true;
                  }
                }
                //周末重复
                else if (timesandformula.时间 == "周末") {
                  if (zhoumo) {
                    this.$message({
                      type: "info",
                      message:
                        "有效期“" + timesandformula.有效期 + "“有多条周末的公式"
                    });
                    b = false;
                    return false;
                  } else {
                    zhoumo = true;
                  }
                }
                //多条空值
                else if (
                  timesandformula.时间 == null ||
                  timesandformula.时间 == ""
                ) {
                  if (kongzhi) {
                    this.$message({
                      type: "info",
                      message:
                        "有效期“" +
                        timesandformula.有效期 +
                        "“有多条时间为空的公式"
                    });
                    b = false;
                    return false;
                  } else {
                    kongzhi = true;
                  }
                }
                //自选时间段
                else if (
                  timesandformula.时间 != null &&
                  timesandformula.时间 != "" &&
                  timesandformula.时间.indexOf("-")
                ) {
                  var timearray = timesandformula.时间.split("-");
                  if (timearray != null && timearray.length > 1) {
                    for (
                      var begin = parseInt(timearray[0]);
                      begin <= parseInt(timearray[1]);
                      begin++
                    ) {
                      nums.push(begin);
                    }
                  }
                }
              });
              //判断自选时间段的有效性，是否互斥，是否遗漏

              var days = 31;
              var iseryue = z.key;
              //判断有效期是否在二月
              if (z.key != null && z.key != "" && z.key.indexOf("到") >= 0) {
                var validityarray = z.key.split("到");
                if (
                  validityarray[0] != null &&
                  validityarray[0] != "" &&
                  validityarray[1] != null &&
                  validityarray[1] != ""
                ) {
                  if (
                    parseInt(validityarray[0].substring(5, 2)) == 2 &&
                    parseInt(validityarray[1].substring(5, 2)) == 2 &&
                    validityarray[0].substring(0, 4) ==
                      validityarray[1].substring(0, 4)
                  ) {
                    days = 28;
                    if (
                      this.isleapyear(
                        parseInt(validityarray[0].substring(0, 4))
                      )
                    ) {
                      days = 29;
                    }
                  }
                }
              }

              for (var dayindex = 1; dayindex <= days; dayindex++) {
                let index = nums.indexOf(dayindex);
                if (index >= 0) {
                  nums.splice(index, 1);
                  if (nums.indexOf(dayindex) >= 0) {
                    this.$message({
                      type: "info",
                      message:
                        "有效期“" + z.key + "“多次维护" + dayindex + "号的公式"
                    });
                    b = false;
                    return false;
                  }
                } else {
                  if (!kongzhi) {
                    this.$message({
                      type: "info",
                      message:
                        "有效期“" + z.key + "“没有维护" + dayindex + "号的公式"
                    });
                    b = false;
                    return false;
                  }
                }
              }
            }
          });
        }
        //时间 重复性和互斥性：同一有效期内不可以有重复的节假日和周末，自选时间段多条之间时间互斥end
      }
      if (b) {
        this.$emit(
          "backServiceCharge",
          this.index,
          JSON.stringify(serviceChargeJSON)
        );
        this.Visible = false;
        this.editVisible(this.tableindex, false, false, false);
      }
    },

    //isleapyear
    isleapyear(year) {
      if ((a % 4 == 0 && !(a % 100 == 0)) || a % 400 == 0) {
        return true;
      }
      return false;
    },
    //增加行
    addRow() {
      this.tableData.push({ times: "", formula: "", validity: "" });
      this.clearEdit();
    },
    //删除行
    deleteRow(index) {
      this.tableData.splice(index, 1);
      this.timesVisible = false;
      this.formulaVisible = false;
      this.clearEdit();
    },
    //清空编辑框
    clearEdit(){
      this.timeradio = "";
      this.tbegin = "";
      this.tend = "";
      this.formula = "";
      this.bdate = "";
      this.edate = "";
    },
    //编辑时间
    editTimes(index) {
      this.clearEdit();
      this.editVisible(index, true, false, false);
      this.times = this.tableData[index].times;
      if (this.times == "节假日" || this.times == "周末") {
        this.timeradio = this.times;
      } else {
        this.timeradio = "自选时间段";
        if (
          this.times != null &&
          this.times != "" &&
          this.times.length > 0 &&
          this.times.indexOf("-")
        ) {
          var timebe = this.times.split("-");
          if (timebe != null && timebe.length > 1) {
            if (timebe[0].length > 1) {
              this.tbegin = timebe[0].substring(0, timebe[0].length - 1);
            }
            if (timebe[1].length > 1) {
              this.tend = timebe[1].substring(0, timebe[1].length - 1);
            }
          }
        }
      }
    },
    //回写时间
    backtimes() {
      var times = "";
      if (this.timeradio == "自选时间段") {
        if (this.tbegin == null || this.tbegin == "") {
          this.$message({
            type: "info",
            message: "请选择开始时间"
          });
          return;
        }
        if (this.tend == null || this.tend == "") {
          this.$message({
            type: "info",
            message: "请选择结束时间"
          });
          return;
        }
        if (this.tbegin > this.tend) {
          this.$message({
            type: "info",
            message: "开始时间不能大于结束时间"
          });
          return;
        }
        times = this.tbegin + "号-" + this.tend + "号";
      } else {
        times = this.timeradio;
      }
      this.tableData[this.tableindex].times = times;
      this.clearEdit();
    },
    cleartimes() {
      this.times = "";
      this.timeradio = "";
      this.tbegin = "";
      this.tend = "";
      this.tableData[this.tableindex].times = "";
    },
    //编辑公式
    editFormula(index) {
      this.editVisible(index, false, true, false);
      this.formula = this.tableData[index].formula;
    },
    //回写公式
    backformula() {
      var b = true;
      var formula = this.formula.replace(/结算方式/g, "1");
      try {
        var result = eval(formula);
      } catch (e) {
        this.$message({
          type: "info",
          message: "公式有误"
        });
        return;
      }
      this.tableData[this.tableindex].formula = this.formula;
      this.clearEdit();
    },
    //判断下一个
    checknext(str) {
      if (str == "+" || str == "-" || str == "*" || str == "/" || str == ")") {
        return false;
      } else {
        return true;
      }
    },
    //清除公式文本框
    clearformula() {
      this.formula = "";
      this.tableData[this.tableindex].formula = "";
    },
    //编辑有效期
    editValidity(index) {
      this.editVisible(index, false, false, true);
      var validity = this.tableData[this.tableindex].validity;
      this.bdate = "";
      this.edate = "";
      if (validity != null && validity != "" && validity.indexOf("到") >= 0) {
        var validitys = validity.split("到");
        this.bdate = validitys[0];
        this.edate = validitys[1];
      }
    },
    //回写有效期
    backvalidity() {
      var validity = "";
      if (
        this.bdate != null &&
        this.bdate != "" &&
        this.edate != null &&
        this.edate != ""
      ) {
        if (this.bdate > this.edate) {
          this.$message({
            type: "info",
            message: "开始时间不能大于结束时间"
          });
          return false;
        }
        validity = this.bdate + "到" + this.edate;
      } else if (
        (this.bdate != null && this.bdate != "") ||
        (this.edate != null && this.edate != "")
      ) {
        validity = this.bdate + "到" + this.edate;
      }
      this.tableData[this.tableindex].validity = validity;
      this.clearEdit();
    },
    //清除有效期
    clearvalidity() {
      this.bdate = "";
      this.edate = "";
      this.tableData[this.tableindex].validity = "";
    },
    //切换显示
    editVisible(index, timesVisible, formulaVisible, validityVisible) {
      this.tableindex = index;
      this.timesVisible = timesVisible;
      this.formulaVisible = formulaVisible;
      this.validityVisible = validityVisible;
    },
    setCalc: function(value) {
      this.formula = this.formula + value;
    },
    closeDialog() {
      this.Visible = false;
      this.timesVisible = false;
      this.formulaVisible = false;
    }
  }
};
</script>
<style>
.el-button-group {
  margin: 1px 0;
}
.formula {
  margin: 10px 0;
}
.computed01 button {
  width: 60px;
}
.computed02 button {
  width: 120px;
}
.bottom-10 {
  margin-bottom: 10px;
}
.timeedit .el-select {
  width: 120px;
}
</style>  

  